var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBean = function SvgBean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.784,
    y: 0.77,
    width: 25.317,
    height: 26.106,
    rx: 12.659,
    fill: "#00546F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.735 15.948c-.7 1.742-1.702 3.066-2.949 3.77-1.215.688-2.768.846-4.734.056-1.966-.79-2.978-1.978-3.38-3.315-.413-1.37-.222-3.02.478-4.762.7-1.741 1.702-3.066 2.948-3.77 1.216-.688 2.77-.846 4.735-.056 1.787.717 2.815 1.902 3.261 3.28.454 1.4.33 3.083-.36 4.797Z",
    stroke: "#fff",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 8.312c0 .122-.036 3.648-2.844 5.136-2.78 1.474-3.427 2.924-3.54 5.76",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
};
export default SvgBean;